export default __webpack_public_path__ + "static/media/img-0160-italy-full-face.29544dfa.png";